var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChaingpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1058,
    height: 228,
    viewBox: "0 0 1058 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M318 119.407C318 154.553 338.452 173 365.403 173H378.403C398.696 173 417.562 159.482 421.367 133.402H406.623C403.452 148.032 391.879 158.846 371.903 158.846C341.781 158.846 332.269 139.922 332.269 118.135V109.865C332.269 88.0782 341.781 68.6765 371.903 68.6765C390.294 68.6765 401.867 78.2183 405.672 91.5768H420.892C415.977 67.8814 397.587 55 378.403 55H365.403C338.452 55 318 73.4474 318 108.593V119.407Z",
    fill: "#EFEFE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M479.002 91.5768C469.807 91.5768 458.868 97.1429 453.161 105.253V55H438.892V170.456H453.161V130.539C453.161 110.978 466.478 105.253 474.405 105.253C487.722 105.253 493.43 111.296 493.43 125.609V170.456H507.698V123.065C507.698 99.3693 492.161 91.5768 479.002 91.5768Z",
    fill: "#EFEFE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M597.112 150.895V123.065C597.112 99.3693 584.904 91.5768 570.794 91.5768H555.257C539.72 91.5768 528.781 103.186 528.781 114.795H543.05C543.05 109.706 548.757 105.253 556.684 105.253H566.196C580.306 105.253 582.526 111.456 582.843 122.111H557.001C538.452 122.111 526.72 131.97 526.72 145.965V147.714C526.72 167.116 542.257 172.841 557.001 172.841C566.831 172.841 578.721 170.456 584.111 162.186C587.282 170.296 596.002 170.456 603.295 170.456V156.779C600.441 156.779 597.112 155.825 597.112 150.895ZM561.599 159.164C546.696 159.164 540.989 155.984 540.989 147.078C540.989 141.989 543.842 134.197 561.599 134.197H582.843V146.76C582.843 156.938 567.94 159.164 561.599 159.164Z",
    fill: "#EFEFE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M628.541 74.0836C633.772 74.0836 638.053 69.9488 638.053 64.7008C638.053 59.4528 633.772 55 628.541 55C623.309 55 619.028 59.4528 619.028 64.7008C619.028 69.9488 623.309 74.0836 628.541 74.0836ZM621.406 170.456H635.675V94.1213H621.406V170.456Z",
    fill: "#EFEFE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M700.245 91.5768C690.574 91.5768 678.842 97.779 673.452 106.685V94.1213H660.134V170.456H674.403V130.539C674.403 110.978 687.72 105.253 695.647 105.253C708.964 105.253 714.672 111.296 714.672 125.609V170.456H728.94V123.065C728.94 99.3693 713.404 91.5768 700.245 91.5768Z",
    fill: "#EFEFE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M854.184 112.569C853.741 112.569 802.024 112.569 802.024 112.569V126.245H839.44V126.563C837.22 144.534 827.232 158.846 801.073 158.846C770.951 158.846 761.438 139.922 761.438 118.135V109.865C761.438 88.0782 770.951 68.6765 801.073 68.6765C822.634 68.6765 832.781 78.5364 837.378 92.2129H852.44C846.891 68.1995 829.927 55 807.573 55H794.573C767.621 55 747.17 73.4474 747.17 108.593V119.407C747.17 154.553 767.621 173 794.573 173H807.573C821.366 173 833.415 168.07 841.659 158.687C849.903 149.305 857.149 131.308 854.184 112.569Z",
    fill: "#EFEFE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M928.652 57.5445H876.968V170.456H891.237V128.949H928.652C946.567 128.949 964.482 121.156 964.482 93.3261C964.482 66.9272 946.567 57.5445 928.652 57.5445ZM925.64 115.272H891.237V71.3801H925.64C943.713 71.3801 949.421 80.6038 949.421 93.3261C949.421 106.049 943.713 115.272 925.64 115.272Z",
    fill: "#EFEFE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1058 57.5445H970.804V71.221H1007.27V170.456H1021.54V71.221H1058V57.5445Z",
    fill: "#EFEFE5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113 26.979H164.561C184.701 26.979 201.022 43.2903 201.022 63.4185V74.3144C201.022 75.864 202.278 77.1201 203.829 77.1201H225.193C226.743 77.1201 228 75.864 228 74.3144V51.2664C228 46.6177 226.156 42.1811 222.875 38.9025L189.075 5.12179C185.778 1.81058 181.388 0 176.72 0H113V26.979Z",
    fill: "url(#paint0_linear_1_1053)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113 201.021H164.561C184.701 201.021 201.022 184.71 201.022 164.581V123.686C201.022 122.136 202.278 120.88 203.829 120.88H225.193C226.743 120.88 228 122.136 228 123.686V176.734C228 181.382 226.156 185.819 222.875 189.097L189.075 222.878C185.778 226.189 181.388 228 176.72 228H113V201.021Z",
    fill: "url(#paint1_linear_1_1053)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114 0L51.2795 8.39078e-05C46.6771 8.39078e-05 42.1726 1.87557 38.9248 5.12092L5.12452 38.9164C1.84406 42.1944 0 46.6301 0 51.2617V114H26.9943V63.4279C26.9943 43.3034 43.3151 26.9951 63.4549 26.9951L114 26.995V0Z",
    fill: "url(#paint2_linear_1_1053)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114 228H51.2795C46.6771 228 42.1726 226.124 38.9248 222.878L5.12452 189.097C1.84406 185.819 0 181.382 0 176.75V113H26.9943V164.581C26.9943 184.71 43.3151 201.021 63.4549 201.021H114V228Z",
    fill: "url(#paint3_linear_1_1053)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5001 132C90.5082 132 97 125.284 97 117C97 108.716 90.5082 102 82.5001 102C74.492 102 68 108.716 68 117C68 125.284 74.492 132 82.5001 132Z",
    fill: "#EFEFE5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 132C155.508 132 162 125.284 162 117C162 108.716 155.508 102 147.5 102C139.492 102 133 108.716 133 117C133 125.284 139.492 132 147.5 132Z",
    fill: "#EFEFE5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1053",
    x1: 221.5,
    y1: 77,
    x2: 115.5,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C5AE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#509ADD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1053",
    x1: 221.5,
    y1: 151,
    x2: 115.5,
    y2: 206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8CF3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1053",
    x1: 109.5,
    y1: 25.4953,
    x2: 29.5181,
    y2: 125.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#509ADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26F4D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_1053",
    x1: 89.5,
    y1: 202,
    x2: 26,
    y2: 110,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CF3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288195,
    stopColor: "#F8CF3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27F3D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaingpt);
export default __webpack_public_path__ + "static/media/chaingpt.e886eeab54c23b0fa5d653bc925cdb3f.svg";
export { ForwardRef as ReactComponent };